
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".75","y":".652","width":"15.4","height":"15","rx":"2.7","stroke":"#56BFC7"}}),_c('path',{attrs:{"d":"M7.893 7.568h-.85a1.058 1.058 0 00-.134-.37.996.996 0 00-.575-.448 1.295 1.295 0 00-.397-.059c-.253 0-.478.064-.673.19-.196.127-.349.311-.46.555-.11.243-.165.54-.165.89 0 .355.055.655.166.9.112.241.265.425.459.55.195.122.419.183.67.183.14 0 .27-.018.391-.054a1.07 1.07 0 00.33-.166 1.013 1.013 0 00.389-.632l.85.004a1.83 1.83 0 01-.207.623 1.836 1.836 0 01-1.007.86c-.228.081-.48.122-.757.122-.41 0-.774-.095-1.096-.284a1.983 1.983 0 01-.759-.82c-.184-.358-.277-.787-.277-1.287 0-.501.093-.93.28-1.286.186-.358.44-.631.761-.82.321-.19.685-.285 1.09-.285.26 0 .5.037.724.11.222.072.42.179.595.32.174.14.318.31.43.513.113.202.188.432.222.691zm4.757 0h-.85a1.056 1.056 0 00-.135-.37.996.996 0 00-.574-.448 1.294 1.294 0 00-.398-.059c-.253 0-.477.064-.673.19-.195.127-.348.311-.459.555-.11.243-.166.54-.166.89 0 .355.055.655.166.9.112.241.265.425.46.55.194.122.418.183.67.183.139 0 .27-.018.39-.054a1.07 1.07 0 00.33-.166 1.011 1.011 0 00.389-.632l.85.004c-.032.222-.101.43-.207.623a1.835 1.835 0 01-1.007.86c-.227.081-.48.122-.757.122-.409 0-.774-.095-1.095-.284a1.983 1.983 0 01-.76-.82c-.184-.358-.277-.787-.277-1.287 0-.501.094-.93.28-1.286.186-.358.44-.631.761-.82.321-.19.685-.285 1.091-.285.26 0 .5.037.723.11.223.072.421.179.595.32.175.14.318.31.43.513.114.202.188.432.223.691z","fill":"#56BFC7"}})])
          )
        }
      }
    